module.exports = __webpack_public_path__ + "static/img/logo.93ffd77a.png";